/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_TitleInputs */

const id_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan LEGO® Star Wars™: The Skywalker Saga GRATIS di Epic Games Store`)
};

const ms_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan LEGO® Star Wars™: The Skywalker Saga PERCUMA di Epic Games Store`)
};

const da_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få LEGO® Star Wars™: The Skywalker Saga GRATIS på Epic Games Store`)
};

const de_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holen Sie sich LEGO® Star Wars™: The Skywalker Saga KOSTENLOS im Epic Games Store`)
};

const en_us2_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get LEGO® Star Wars™: The Skywalker Saga for FREE on Epic Games Store`)
};

const es_es2_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigue LEGO® Star Wars™: The Skywalker Saga GRATIS en la Epic Games Store`)
};

const es_mx2_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigue LEGO® Star Wars™: The Skywalker Saga GRATIS en la Epic Games Store`)
};

const fil_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunin ang LEGO® Star Wars™: The Skywalker Saga nang LIBRE sa Epic Games Store`)
};

const fr_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenez LEGO® Star Wars™ : The Skywalker Saga GRATUITEMENT sur l'Epic Games Store`)
};

const it_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni LEGO® Star Wars™: The Skywalker Saga GRATIS sull'Epic Games Store`)
};

const hu_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szerezd meg a LEGO® Star Wars™: The Skywalker Saga játékot INGYEN az Epic Games Store-ban`)
};

const nl_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg LEGO® Star Wars™: The Skywalker Saga GRATIS in de Epic Games Store`)
};

const no_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få LEGO® Star Wars™: The Skywalker Saga GRATIS på Epic Games Store`)
};

const pl_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdobądź LEGO® Star Wars™: The Skywalker Saga ZA DARMO w Epic Games Store`)
};

const pt_br2_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha LEGO® Star Wars™: A saga Skywalker GRATUITAMENTE em Epic Games Store`)
};

const pt_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha LEGO® Star Wars™: The Skywalker Saga GRÁTIS na Epic Games Store`)
};

const ro_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obține LEGO® Star Wars™: The Skywalker Saga GRATUIT pe Epic Games Store`)
};

const fi_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanki LEGO® Star Wars™: The Skywalker Saga ILMAISEKSI Epic Games Storesta`)
};

const sv_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få LEGO® Star Wars™: The Skywalker Saga GRATIS på Epic Games Store`)
};

const vi_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận LEGO® Star Wars™: The Skywalker Saga MIỄN PHÍ trên Epic Games Store`)
};

const tr_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO® Star Wars™: The Skywalker Saga'yı Epic Games Store'da ÜCRETSİZ Edinin`)
};

const cs_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získejte LEGO® Star Wars™: The Skywalker Saga ZDARMA na Epic Games Store`)
};

const bg_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вземете LEGO® Star Wars™: The Skywalker Saga БЕЗПЛАТНО в Epic Games Store`)
};

const ru_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите LEGO® Star Wars™: The Skywalker Saga БЕСПЛАТНО в Epic Games Store`)
};

const uk_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримайте LEGO® Star Wars™: The Skywalker Saga БЕЗКОШТОВНО в Epic Games Store`)
};

const ar_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على LEGO® Star Wars™: The Skywalker Saga مجانًا في Epic Games Store`)
};

const hi_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO® Star Wars™: The Skywalker Saga मुफ़्त पाएँ`)
};

const th_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับ LEGO® Star Wars™: The Skywalker Saga ฟรีบน Epic Games Store`)
};

const ja_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO® Star Wars™: The Skywalker Saga を Epic Games Store で無料で入手`)
};

const zh_cn2_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Epic Games Store 免费领取 LEGO® Star Wars™: The Skywalker Saga`)
};

const zh_hant1_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Epic Games Store 免費領取 LEGO® Star Wars™: The Skywalker Saga`)
};

const ko_misc_posts_title = /** @type {(inputs: Misc_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store에서 LEGO® Star Wars™: The Skywalker Saga를 무료로 받으세요`)
};

/**
* | output |
* | --- |
* | "Get LEGO® Star Wars™: The Skywalker Saga for FREE on Epic Games Store" |
*
* @param {Misc_Posts_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_title = /** @type {((inputs?: Misc_Posts_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_title(inputs)
	if (locale === "ms") return ms_misc_posts_title(inputs)
	if (locale === "da") return da_misc_posts_title(inputs)
	if (locale === "de") return de_misc_posts_title(inputs)
	if (locale === "en-US") return en_us2_misc_posts_title(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_title(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_title(inputs)
	if (locale === "fil") return fil_misc_posts_title(inputs)
	if (locale === "fr") return fr_misc_posts_title(inputs)
	if (locale === "it") return it_misc_posts_title(inputs)
	if (locale === "hu") return hu_misc_posts_title(inputs)
	if (locale === "nl") return nl_misc_posts_title(inputs)
	if (locale === "no") return no_misc_posts_title(inputs)
	if (locale === "pl") return pl_misc_posts_title(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_title(inputs)
	if (locale === "pt") return pt_misc_posts_title(inputs)
	if (locale === "ro") return ro_misc_posts_title(inputs)
	if (locale === "fi") return fi_misc_posts_title(inputs)
	if (locale === "sv") return sv_misc_posts_title(inputs)
	if (locale === "vi") return vi_misc_posts_title(inputs)
	if (locale === "tr") return tr_misc_posts_title(inputs)
	if (locale === "cs") return cs_misc_posts_title(inputs)
	if (locale === "bg") return bg_misc_posts_title(inputs)
	if (locale === "ru") return ru_misc_posts_title(inputs)
	if (locale === "uk") return uk_misc_posts_title(inputs)
	if (locale === "ar") return ar_misc_posts_title(inputs)
	if (locale === "hi") return hi_misc_posts_title(inputs)
	if (locale === "th") return th_misc_posts_title(inputs)
	if (locale === "ja") return ja_misc_posts_title(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_title(inputs)
	return ko_misc_posts_title(inputs)
});
export { misc_posts_title as "misc.posts.title" }